<!-- @format -->
<template>
	<div :style="style" class="powerpass_container">
		<iframe
			:id="iframeId"
			ref="refIframe"
			:src="link"
			frameborder="no"
			width="100%"
			height="100%"
			scrolling="auto"
			@load="onLoadIframe"
		/>
	</div>
</template>
<script setup lang="ts">
	import { useGlobalStoreWithOut, getEnvUrlByUrl } from '@power/runtime-vue3';
	import { injectCssToIframeDocument, injectCssToDocument } from '@power/utils';
	import { useRouterStoreWithOut } from '@/store/modules/router';
	const routerStore = useRouterStoreWithOut();
	const globalStore = useGlobalStoreWithOut();
	const link = ref('');
	if (routerStore.linkUrl) {
		link.value = getEnvUrlByUrl(routerStore.linkUrl);
	}
	const iframeId = computed(() => link.value);
	const refIframe = ref(null);
	// const height = !globalStore.visible.pcLayoutHeader
	// 	? `${document.documentElement.clientHeight}px`
	// 	: `${document.documentElement.clientHeight - 55 - 16 * 2 - 16 * 2}px`;

	const height = !globalStore.visible.pcLayoutHeader
		? `${document.documentElement.clientHeight}px`
		: `${document.documentElement.clientHeight - 55}px`;

	const style = { height };

	const onLoadIframe = () => {
		console.log('routerStore.linkUrl', routerStore.linkUrl);

		const cssUrl = getEnvUrlByUrl(`power-front-base/frontend/css/commonstyle.css`);
		injectCssToIframeDocument(document, iframeId.value, cssUrl);
		injectCssToDocument(document, cssUrl);
	};
	watch(
		() => routerStore.linkUrl,
		() => {
			const link = routerStore.linkUrl;
			const url = getEnvUrlByUrl(decodeURIComponent(link));
			refIframe.value?.setAttribute('src', url);
		},
	);
</script>

<style lang="scss">
	.pc-layout-main-el-main:has(> .powerpass_container) {
		margin: 0 !important;
		padding: 0 !important;
		height: calc(100vh - var(--theme-header-height)) !important;
		width: 100%;
	}
</style>
